/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Everything_ProInputs */

const en_landing_pricing_feature_everything_pro = /** @type {(inputs: Landing_Pricing_Feature_Everything_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything in Pro`)
};

const zh_landing_pricing_feature_everything_pro = /** @type {(inputs: Landing_Pricing_Feature_Everything_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含专业版全部功能`)
};

/**
* | output |
* | --- |
* | "Everything in Pro" |
*
* @param {Landing_Pricing_Feature_Everything_ProInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_everything_pro = /** @type {((inputs?: Landing_Pricing_Feature_Everything_ProInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Everything_ProInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_everything_pro(inputs)
	return zh_landing_pricing_feature_everything_pro(inputs)
});
export { landing_pricing_feature_everything_pro as "landing.pricing.feature_everything_pro" }